import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "../..";
import TransmedAdmin from "../../../dtos/transmed/process/admin";
import TransmedEdition, {
  TransmedEditionInput,
  TransmedEditionSeason,
} from "../../../dtos/transmed/process/edition";
import TransmedAdminApi from "../../../api/transmed/admin";
import TransmedEditionApi from "../../../api/transmed/edition";
import TransmedProcessApi from "../../../api/transmed/process";
import OutputTransmedProcess from "../../../dtos/transmed/process/process";

class TransmedProcessServiceReader extends ServiceReader {
  public async current(): Promise<OutputTransmedProcess> {
    return await new TransmedProcessApi().get();
  }

  public async admin(): Promise<TransmedAdmin> {
    const api = new TransmedAdminApi();
    return await api.get();
  }

  public async edition(): Promise<TransmedEdition> {
    const api = new TransmedEditionApi();
    return await api.get();
  }
}

class TransmedProcessServiceCreator extends ServiceCreator {
  public async start(): Promise<TransmedEdition> {
    const api = new TransmedEditionApi();
    return await api.post();
  }
}

class TransmedProcessServiceUpdater extends ServiceUpdater {
  public async edition(
    year: number,
    season: TransmedEditionSeason,
    periodText: string,
    registration_start: Date,
    registration_end: Date,
    max_points: number,
    points_deadline_first: Date,
    contesting_deadline: Date,
    points_deadline_second: Date,
    distribution_start: Date,
    exchange_start: Date,
    exchange_end: Date,
    participation_proof_deadline: Date,
    regulations: File | null,
    participation_proof_template: File | null
  ): Promise<TransmedEdition> {
    const api = new TransmedEditionApi();

    return await api.put(
      "last",
      new TransmedEditionInput(
        year,
        season,
        periodText,
        registration_start,
        registration_end,
        max_points,
        points_deadline_first,
        contesting_deadline,
        points_deadline_second,
        distribution_start,
        exchange_start,
        exchange_end,
        participation_proof_deadline,
        regulations,
        participation_proof_template
      )
    );
  }
}
class TransmedProcessServiceDeleter extends ServiceDeleter {}

export default class TransmedProcessService extends Service {
  public get read(): TransmedProcessServiceReader {
    return new TransmedProcessServiceReader();
  }
  public get create(): TransmedProcessServiceCreator {
    return new TransmedProcessServiceCreator();
  }
  public get update(): TransmedProcessServiceUpdater {
    return new TransmedProcessServiceUpdater();
  }
  public get delete(): TransmedProcessServiceDeleter {
    return new TransmedProcessServiceDeleter();
  }
}
